import { render } from "./OutputText.vue?vue&type=template&id=432eb664"
import script from "./OutputText.vue?vue&type=script&lang=js"
export * from "./OutputText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__